import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { trackEvent } from "../helpers";
import Activity from "../utils/icons/Activity";

import FilePlus from "../utils/icons/FilePlus";
import Send from "../utils/icons/Send";
import Tool from "../utils/icons/Tool";

export default function CampaignSteps() {
  const history = useHistory();
  const match = useRouteMatch("/campaigns/edit/:id/:step");
  const id = match.params.id;
  const currentStep = match.params.step;

  return (
    <>
      <div className="post-steps rel">
        <div className="center">
          <div className={currentStep === "publishing" ? "active" : ""}>
            <button
              className="reset with-icon"
              onClick={() => {
                trackEvent("subnav_publishing");
                history.push(`/campaigns/edit/${id}/publishing`);
              }}
            >
              <Send size={18} />
              Publishing
            </button>
          </div>
          <div className={currentStep === "content" ? "active" : ""}>
            <button
              className="reset with-icon"
              onClick={() => {
                trackEvent("subnav_content");
                history.push(`/campaigns/edit/${id}/content`);
              }}
            >
              <FilePlus size={18} />
              Content
            </button>
          </div>
          <div className={currentStep === "editor" ? "active" : ""}>
            <button
              className="reset with-icon"
              onClick={() => {
                trackEvent("subnav_editor");
                history.push(`/campaigns/edit/${id}/editor`);
              }}
            >
              <Tool size={18} />
              Editor
            </button>
          </div>
          <div className={currentStep === "report" ? "active" : ""}>
            <button
              className="reset with-icon"
              onClick={() => {
                trackEvent("subnav_report");
                history.push(`/campaigns/edit/${id}/report`);
              }}
            >
              <Activity size={18} />
              Report
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
